module.exports = __webpack_public_path__ + "media/images/favicon-9276e8b242a3b8744be45f438fe25ef6.ico";